module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13igUsF/tc-custom/9781504082419.jpg?1705261436756",
      "alt": "This image is the cover for the book Ghostwriter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghostwriter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A brand-new thriller by the bestselling author of "), _c('i', [_vm._v("Girl in Bed Three")]), _vm._v(". A writer helps a victim of abuse tell her tale and finds herself becoming part of the story . . .")]), _c('br'), _c('br'), _vm._v(" Single mother Polly has been struggling since work started to dry up, so she is hugely relieved when her sister contacts her about a potential ghostwriting job. And the woman who wants to hire Polly has a hell of a tale to tell. Sylvie was once trapped in a criminal underworld by her boyfriend who has since been jailed. She wants to share her story to help other women escape their abusive relationships . . . what could possibly go wrong?"), _c('br'), _c('br'), _vm._v(" Yet when Sylvie’s ex is paroled and she lets him back into her life, Polly wonders if the project is a mistake."), _c('br'), _c('br'), _vm._v(" With more at stake than just a book, can Polly get out of a very dangerous situation with her life intact?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Sheridan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0